import React, { useEffect, useState } from 'react'
import { cmsDataService, memberService, navigationService } from '../../../services'
import { Button, ButtonColor } from '@vista-digital/occ-ui'
import { PagesEnum } from '../../../pages/pages'
import { isMemberSignedIn, loadMember } from '@vista-digital/occ-domain'
import { useLocation } from 'react-router-dom'
import { closeBurgerMenu } from './Burger'

export const MemberStatus: React.FC = () => {
    const { showSignIn, signInText } = cmsDataService.get().header

    const [loadingMember, setLoadingMember] = useState(true)
    const [loadingError, setLoadingError] = useState(false)
    const [memberName, setMemberName] = useState('')
    const signedIn = isMemberSignedIn()

    const page = useLocation()

    useEffect(() => {
        if (signedIn) {
            setLoadingMember(true)
            loadMember()
                .then(member => {
                    memberService.setMember(member)
                    setMemberName(`${member.personalDetails.name.givenName} ${member.personalDetails.name.familyName}`)
                }, onLoadingError)
                .catch(onLoadingError)
                .finally(() => {
                    setLoadingMember(false)
                })
        } else setLoadingMember(false)
    }, [page, signedIn])

    const onLoadingError = () => {
        setLoadingError(true)
        memberService.setMember(null)
    }

    const signInClickHandler = () => {
        navigationService.goToPage(PagesEnum.Login)
        closeBurgerMenu()
    }

    const memberClickHandler = () => {
        navigationService.goToPage(PagesEnum.MemberOverview)
        closeBurgerMenu()
    }

    return (
        <div className="nav-sign-in">
            {!signedIn && showSignIn && (
                <div className="header-sign-in">
                    <Button
                        color={ButtonColor.Tertiary}
                        label={signInText || 'Login'}
                        onClick={signInClickHandler}
                        iconName="member-icon"
                    />
                </div>
            )}
            {signedIn && !loadingMember && !loadingError && (
                <div className="header-member">
                    <Button
                        color={ButtonColor.Tertiary}
                        label={'Hi, ' + memberName}
                        onClick={memberClickHandler}
                        iconName="member-icon"
                    />
                </div>
            )}
        </div>
    )
}
